module.exports = __webpack_public_path__ + "assets/sitefinity.ef713c61.svg";